import { render, staticRenderFns } from "./PFContentCentered.vue?vue&type=template&id=54c36390&scoped=true&"
import script from "./PFContentCentered.vue?vue&type=script&lang=js&"
export * from "./PFContentCentered.vue?vue&type=script&lang=js&"
import style0 from "./PFContentCentered.vue?vue&type=style&index=0&id=54c36390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c36390",
  null
  
)

export default component.exports